export const getAccessTokenFromStorage = () => {
    return window.localStorage.getItem("accessToken");
}

export const setAccessTokenInStorage = (accessToken: any) => {
    if(accessToken === null)
        window.localStorage.removeItem("accessToken");
    else
        window.localStorage.setItem("accessToken", accessToken);
}

export const getTenantNameFromStorage = () => {
    return window.localStorage.getItem("tenantName");
}

export const setTenantNameInStorage = (tenantName: any) => {
    if(tenantName === null)
        window.localStorage.removeItem("tenantName");
    else
        window.localStorage.setItem("tenantName", tenantName);
}